export default __webpack_public_path__ + "static/icon-ai-fe2c3b4cc15b508a6af23a03a97a1d44.svg";